(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dear-footer"] && !Shopify.designMode) return;
  try {
    
const updateSticky = () => document.body.classList.toggle('dp-scrolled', window.scrollY > 420);
window.addEventListener('scroll', updateSticky, { passive: true });
updateSticky();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dear-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.dp-gallery-open');
  if (trigger) {
    const dialog = trigger.closest('.dp-gallery-section').querySelector('dialog');
    dialog.querySelector('img').src = trigger.querySelector('img').currentSrc;
    dialog.showModal();
  }
  if (event.target.matches('.dp-lightbox, .dp-lightbox-close')) event.target.closest('dialog').close();
});

  } catch(e) { console.error(e); }
})();
})();
